import React, { useContext, useEffect, useState } from "react";
import {
  apiRequest,
  catchErrorMessageHandler,
  getUserSelectedRole,
} from "../../infrastructure/backendService";
import { CMS_BASE_URL } from "../../config/apiUrl";
import styles from "./hallContractForm.module.scss";
import apiPath from "../../config/apiPaths.json";
import {
  CommonButton,
  CommonOutlinedButton,
  CustomCalendarTodayOutlinedIcon,
  CustomDatePicker,
  CustomRequiredInputLabel,
  CustomTextFeildforFamily,
  StyledDateContainer,
} from "../common/StyledComponents/StyledFields";
import toast, { Toaster } from "react-hot-toast";
import SuccessPopup from "../devotee/donation/successPopup";
import LOCALE from "../../config/en-us.json";
import ToastSuccess from "../common/toast/toastSuccess";
import { useNavigate } from "react-router-dom";
import { Box, Checkbox, Grid } from "@mui/material";
import dayjs from "dayjs";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import constants from "../../config/constants.json";
import { MyContext } from "./formTwo/formTwo";
import { ContextFour } from "./formFour/formFour";
import { isEmpty, isNil } from "lodash";
import ErrorPopup from "../common/ErrorPopup";
import { useSearchParams } from "react-router-dom";
import { textAlign } from "html2canvas/dist/types/css/property-descriptors/text-align";
import { RoutingURLs, SubRoutingURLs } from "../common/RoutingURLs";

interface fromNineProps {
  updateParentState: (newState: boolean) => void;
  formData: any;
}

const FormNine = (props: fromNineProps) => {
  const navigate = useNavigate();
  const [html, setHTML] = useState({ __html: "" });
  const [isChecked,setIsChecked]=useState(false);
  const [isDatePickerOpen, setDatePickerOpen] = useState(false);
  const [isDatePickerWedingOpen, setDatePickerWedingOpen] = useState(false);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate()); // Get tomorrow's date
  const options: Intl.DateTimeFormatOptions = {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  };

  const usaFormattedDate = currentDate
    .toLocaleDateString("en-US", options)
    .replace(/\//g, "-");
  const [formData, setFormData] = useState({
    signature: "",
    date: usaFormattedDate,
  });
  const context = useContext(MyContext);
  const contextFourValue = useContext(ContextFour);
  const hasManagerLevelRole = constants.showDashBoardForRoles.includes(
    getUserSelectedRole() || ""
  );
  const [managerFullName, setManagerFullName] = useState("");

  useEffect(() => {
    if (
      !isNil(contextFourValue?.object1.hccc) &&
      !isEmpty(contextFourValue?.object1.hccc)
    ) {
      apiRequest({
        method: "GET",
        endpoint: `${
          apiPath.getDevoteeDetails
        }/${contextFourValue?.object1.hccc.toUpperCase()}`,
        includeToken: true,
      })
        .then((res) => {
          setManagerFullName(
            `${res.data.firstname} ${res.data.middleName} ${res.data.lastname}`
          );
        })
        .catch((err) => {
          console.log(err);
          toast.custom(
            <ErrorPopup
              showMessage={catchErrorMessageHandler(err)}
              isOpen={false}
            />,
            {
              duration: constants.TOAST_POPUP_DURATION,
            }
          );
        });
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    apiRequest({
      method: "GET",
      basePath: `${CMS_BASE_URL}`,
      includeToken: false,
      endpoint: "/wp-json/wp/v2/hccc-page",
      params: {
        slug: "facility-usage-application-p9",
      },
    })
      .then((res) => {
        const acfContent = res.data[0]?.acf?.hccc_page || "";
        // const styledContent = acfContent.replace(
        //   /<p class="MuiTypography-root MuiTypography-body1 _headername_8c7n3_281 css-9l3uo3">/g,
        //   `<p class="${styles.headername}">`
        // );
        setHTML({ __html: acfContent });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleClick = () => {
    props.updateParentState(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const [searchParam] = useSearchParams();

  const hallBookingId = searchParam.get("hallBookingId");
  const contractId = searchParam.get("contractId");
  const status = searchParam.get("STATUS");

  let PatchReq = JSON.parse(`{
    "eventDuration": 0,
    "eventGuestCount": 0,
    "eventHalls": [
      {
        "id": 0,
        "name": "string",
        "minimumFee": 0,
        "hourlyFee": 0,
        "setupAndCleaning": 0,
        "securityDeposit": 0,
        "eventDate": "2024-03-04T07:29:37.570Z",
        "eventDuration": 0,
        "eventStartTime": "2024-03-04T07:29:37.570Z",
        "eventEndTime": "2024-03-04T07:29:37.570Z"
      }
    ],
    "facilityUsageReservationFee": 0,
    "furnitureSetupBreakdownCleaningFee": 0,
    "securityDeposit": 0,
    "initialAmountToPay": 0,
    "finalAmountToPay": 0,
    "managerUsername": "string",
    "managerFullname": "string",
    "managerPhoneNumber": "string",
    "managerAcknowledgedAuthorityToSign": true,
    "managerAcknowledgedAuthorityToSignDate": "2024-03-04T07:29:37.570Z"
  }`);
  const [patchReq, setPatchReq] = useState({ ...PatchReq });



  const devoteeSignApiCall = () => {
    const reqBody = {
      devoteeSignature: formData.signature,
      devoteeAcknowledgedAgreement: true,
      devoteeAgreementSignedDate: formData.date,
    };
    apiRequest({
      method: "PATCH",
      endpoint: `${apiPath.contractFormHallBookingManagerFlow}/${hallBookingId}/contracts/${contractId}/signature/lessee`,
      includeToken: true,
      body: JSON.stringify(reqBody),
    })
      .then((res) => {
        const successMessage = "Contract Signed Successfully.";
        toast.custom(
          <SuccessPopup
            showMessage={successMessage}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
        if (hasManagerLevelRole) {
          navigate(
            `/managerDashboard/devoteeservice/${SubRoutingURLs.DEVOTEE_POOJA_AND_HALL_REQUESTS}`
          );
        } else {
          navigate(RoutingURLs.dashboard);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const patchApiCall = () => {
    if (hasManagerLevelRole) {
      const updatedPatchReq = {
        ...patchReq,
        eventDuration: props.formData.duration,
        eventGuestCount: props.formData.eventGuestCount,
        eventHalls: context.tableEventFormData.map((item) => ({
          ...item,
          id: contextFourValue?.object2?.id,
          name: item.facilityTitle,
          minimumFee: contextFourValue?.object2?.minimumFee,
          hourlyFee: contextFourValue?.object2?.hourlyFee,
          furnitureSetupBreakdownCleaningFee:
            contextFourValue?.object2?.setupAndCleaning,
          securityDeposit: contextFourValue?.object2?.securityDeposit,
          eventDate: item.eventDate,
          eventDuration: item.totalHours,
          eventStartTime: item.eventTime.fromTime,
          eventEndime: item.eventTime.toTime,
          totalAmount: item.amountTotal,
        })),
        managerAcknowledgedAuthorityToSignDate: usaFormattedDate,
        facilityUsageReservationFee: contextFourValue?.object1.reservationFee,
        furnitureSetupBreakdownCleaningFee:
          contextFourValue?.object1.furnitureCharges,
        securityDeposit: contextFourValue?.object1.securityDeposit,
        initialAmountToPay: contextFourValue?.object1.initialAmount,
        finalAmountToPay: contextFourValue?.object1.finalAmount,
        managerUsername: contextFourValue?.object1.hccc,
        managerFullname: managerFullName,
        managerPhoneNumber: contextFourValue?.object1.phone,
      };
      //setPatchReq(updatedPatchReq);
      apiPatchCall(updatedPatchReq);
    }
  };

  const apiPatchCall = (updatedPatchReq: any) => {
    apiRequest({
      method: "PATCH",
      endpoint: `${apiPath.contractFormHallBookingManagerFlow}/${hallBookingId}/contracts/${contractId}/facilityUsageFee`,
      includeToken: true,
      body: JSON.stringify(updatedPatchReq),
    })
      .then((res) => {
        const successMessage = "Contract Details Updated Successfully.";
        toast.custom(
          <SuccessPopup
            headerMessage="Contract Details"
            showMessage={successMessage}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
        if (hasManagerLevelRole) {
          navigate(
            `/managerDashboard/devoteeservice/${SubRoutingURLs.DEVOTEE_POOJA_AND_HALL_REQUESTS}`
          );
        } else {
          navigate(RoutingURLs.dashboard);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleButtons = () => {
    return (
      <div style={{ display: "flex", gap: "1rem" }}>
        <CommonOutlinedButton>Cancel</CommonOutlinedButton>
        <CommonButton>Submit</CommonButton>
      </div>
    );
  };

  const apiCall = () => {
    if (status === "FORM_TO_BE_SIGNED") {
      devoteeSignApiCall();
    } else {
      apiRequest({
        method: "POST",
        endpoint: apiPath.hallBookingContractRequest,
        includeToken: true,
        body: JSON.stringify(props.formData),
      })
        .then((res) => {
          const successMessage = "Hall Booking request sent to Manager for Approval.";
          toast.custom(
            <SuccessPopup
              showMessage={successMessage}
              isOpen={isOpen}
              setIsOpen={setIsOpen}
              
            />,
            {
              duration: constants.TOAST_POPUP_DURATION,
            }
          );
          if (hasManagerLevelRole) {
            navigate(
              `/managerDashboard/devoteeservice/${SubRoutingURLs.DEVOTEE_POOJA_AND_HALL_REQUESTS}`
            );
          } else {
            navigate(RoutingURLs.dashboard);
          }
          //  toast.custom(<ToastSuccess message={successMessage} sent={""} />, {
          //   duration: 10000,
          // });
          //navigate("/managerDashboard/devoteeservice/Devotee Pooja & Hall Requests");
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const handleFieldChange = (field: string, value: any) => {
    if (field === "date") {
      const formattedDate = dayjs(value, "MM-DD-YYYY");
      setDatePickerOpen(false);
      setFormData({
        ...formData,
        [field]: formattedDate.isValid()
          ? formattedDate.format("MM-DD-YYYY")
          : "",
      });
    } else {
      setFormData({
        ...formData,
        [field]: value,
      });
    }
  };

  const signatureComponent = (): JSX.Element => {
    return (
      <Grid xs={12} sm={3} item>
        <CustomTextFeildforFamily
          style={{
            display:
              !(status === "FORM_TO_BE_SIGNED") || hasManagerLevelRole
                ? "none"
                : "block",
          }}
          sx={{
            border: "1px solid rgba(136, 46, 20, 0.4)",
            borderRadius: "8px",
          }}
          className={styles.textField}
          disabled={!(status === "FORM_TO_BE_SIGNED")}
          value={formData.signature}
          onChange={(e) => {
            handleFieldChange("signature", e.target.value);
          }}
        />
        {status === "FORM_TO_BE_SIGNED" &&
          CustomRequiredInputLabel("(Signature of the lessee)", false)}
          {(status === "FORM_TO_BE_SIGNED") && <div><Checkbox onClick={()=>setIsChecked(!isChecked)} checked={isChecked}/><span style={{color:"red"}}>I agree</span></div>}
      </Grid>
    );
  };

  const handleDatePickerClick = () => {
    setDatePickerOpen(true);
  };

  const dateFormate = () => {
    let currentDate = new Date();
    var usaDateFormat =
      currentDate.getMonth() +
      1 +
      "-" +
      currentDate.getDate() +
      "-" +
      currentDate.getFullYear();
  };

  const TodaysDateInput = () => {
    return (
      <CustomTextFeildforFamily
          style={{
            display:
              !(status === "FORM_TO_BE_SIGNED") || hasManagerLevelRole
                ? "none"
                : "block",
          }}
          disabled={!(status === "FORM_TO_BE_SIGNED")}
          value={usaFormattedDate}
        />
    );
  };

  const BasicDatePicker = (): React.ReactElement => {
    return (
      <div
        style={{
          minWidth: "20px",
          height: "48px",
          borderRadius: "8px",
          width: "200px",
          border: "1px solid rgba(136, 46, 20, 0.4)",
          display:
            !(status === "FORM_TO_BE_SIGNED") || hasManagerLevelRole
              ? "none"
              : "block",
        }}
      >
        <StyledDateContainer
          sx={{
            backgroundColor: "#fff",
            borderRadius: "8px",
            height: "48px",
          }}
          onClick={handleDatePickerClick}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateTimePicker"]}>
              <CustomDatePicker
                open={isDatePickerOpen}
                onClose={() => setDatePickerOpen(false)}
                slots={{
                  openPickerIcon: CustomCalendarTodayOutlinedIcon,
                }}
                slotProps={{
                  inputAdornment: {
                    position: "end",
                  },
                }}
                format="MM-DD-YYYY"
                // value={dateFormate()}
                value={formData.date ? dayjs(formData.date, "MM-DD-YYYY") : ""}
                onChange={(value) => {
                  handleFieldChange("date", value);
                }}
                disabled={true}
                readOnly
              />
            </DemoContainer>
          </LocalizationProvider>
        </StyledDateContainer>
      </div>
    );
  };

  const FormStepContent = () => (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <span className={styles.currentStepStyles}>9</span>{" "}
      <span style={{ padding: "5px 10px 5px 10px" }}>/ 9</span>
    </div>
  );

  const navigationButtons = () => {
    return (
      <div style={{ display: "flex", gap: "10px" }}>
        <CommonOutlinedButton
          startIcon={<ChevronLeftIcon />}
          onClick={handleClick}
        >
          Previous
        </CommonOutlinedButton>
        {FormStepContent()}
        <CommonButton endIcon={<KeyboardArrowRightIcon />} disabled>
          Next
        </CommonButton>
      </div>
    );
  };

  const handleCancel = () => {
    if (hasManagerLevelRole) {
      navigate(
        `/managerDashboard/devoteeservice/${SubRoutingURLs.DEVOTEE_POOJA_AND_HALL_REQUESTS}`
      );
    } else {
      navigate(RoutingURLs.dashboard);
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div>
      <div style={{ display: "flex", flexDirection: "column" }}>
        {/* <div
          style={{
            display: "flex",
            gap: "1rem",
            float: "right",
            marginBottom: "40px",
            marginLeft: "auto",
          }}
        >
          {navigationButtons()}
        </div> */}
        <div>
          <div dangerouslySetInnerHTML={html} />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            margin: "10px 0px",
          }}
        >
          {signatureComponent()}
          {TodaysDateInput()}
          {/* {BasicDatePicker()} */}
        </div>
        <Box sx={{display: "flex", justifyContent: "flex-end"}}>
          {navigationButtons()}
        </Box>
        <div
          style={{
            display: "flex",
            gap: "1rem",
            float: "right",
            marginTop: "20px",
            marginLeft: "auto",
          }}
        >
          <CommonOutlinedButton
            style={{
              display: status === "viewcontractform" ? "none" : "block",
            }}
            sx={{ display: "flex", float: "right" }}
            onClick={handleCancel}
          >
            Cancel
          </CommonOutlinedButton>
          <CommonButton
            disabled={
              status === "FORM_TO_BE_SIGNED" &&
              (!isChecked || formData.signature.trim().length < 1)
            }
            style={{
              display: status === "viewcontractform" ? "none" : "block",
            }}
            sx={{ display: "flex", float: "right" }}
            onClick={hasManagerLevelRole ? patchApiCall : apiCall}
          >
            Submit
          </CommonButton>
        </div>
      </div>
    </div>
  );
};

export default FormNine;
